import styled from 'styled-components';
import { Link } from 'react-router-dom';

import colors from '../../../styles/colors';

export const Container = styled.div`
  background-color: white;
  width: 80%;
  height: 350px;
  border: 1px solid ${colors.lightgray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContainerText = styled.div`
  padding-top: 80px;
  padding-bottom: 20px;
  width: 80%;
`;

export const Text = styled.h1`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: ${colors.blueEinstein};
  font-weight: 400;
  font-size: 20px;
`;

export const ContainerTitulo = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Titulo = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.blueEinstein};
  font-weight: 400;
  font-size: 17px;
  width: 150px;
`;

export const ContainerNav = styled.div`
  padding-top: 20px;
`;

export const Nav = styled(Link)`
  color: ${colors.blueEinstein3};
  text-decoration: underline;
`;

export const TextNav = styled.span`
  color: ${colors.gray5};
`;
